export const drawerWidth = 240;
export const collapsedDrawerWidth = 65;
export const defaultToolbarHeight = 44;
export const toolbarSpacing = 16;

export const rightDrawerWidth = window.innerWidth > 1600 ? window.innerWidth * 0.35 : window.innerWidth * 0.45;
export const collapsedRightDrawerWidth = 0;
